<template>
    <div class="flex1 ml10 container" style="height:100%"   
          @dblclick="closeani"
    
     >
          <el-amap
          class="amap-box"
          vid="amap"
          :zoom="zoom"
          :resizeEnable="true"
          :center="position"
        >
          <!-- <el-amap-marker
        vid="component-marker"
        :position="position"
        :icon="icon"
        v-if="isWaring"
      ></el-amap-marker> -->
          <el-amap-marker
            vid="component-marker"
            v-for="(item, index) of marker"
            :position="item.position"
            :events="item.loca"
            :animation="
              item.animate && aniIndex
                ? 'AMAP_ANIMATION_BOUNCE'
                : 'AMAP_ANIMATION_NONE'
            "
          ></el-amap-marker>
          <el-amap-text
        :zIndex="99999"
        :visible="item.showmod || showmodall"
        v-for="item in marker"
        :text="item.text"
        :offset="[0, 30]"
        :position="item.position"
      ></el-amap-text>

          <!-- <info @local="showpos"></info> -->
        </el-amap>
<!-- 
         <el-dialog
      title="单位详情"
      style="min-height: 500px"
      :visible.sync="showmod"
      width="90%"
      :close-on-click-modal="false"
    >
      <company :c_num="c_num" />
    </el-dialog> -->
    </div>
</template>
<script>
import company from "@/components/company.vue";

export default {
    props:[
        'marker',
        'c_num'
    ],
  
  data(){
      return{
         position:  [120.36173, 36.082949],
      zoom: 13,
      showmod:false,
      aniIndex:false,
      showmodall:false,
      params: { page: 1 },
      }
  },
  
  created(){
        this.getPos()

  },
  methods:{
      getPos(){
            if(this.marker.length==1){
          this.position = this.marker[0].position
      }
      },
      closeani(){
          this.marker.map(item=>{
            item.animate = false
            this.aniIndex=false
          })
      }
  },    
  watch:{
      marker(v){
        //   console.log(v)
        this.getPos()
      },
      c_num(v){
        // alert(v)
        this.marker.map(item=>{
          item.animate=false
          if(item.c_company_num ==v){
            item.animate=true
            this.aniIndex=true
            this.position = item.position
            this.zoom=22
          }
        })
      }
  },
 
}
</script>

<style scoped lang="scss">
    .container{
  height: 38vw;
}
</style>